import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, GeneralConfigType, KeyValues5, KeyValueSet, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';

@Component({
  selector: 'app-config-serial-numbers',
  templateUrl: './config-serial-numbers.component.html',
  styleUrls: ['./config-serial-numbers.component.scss']
})
export class ConfigSerialNumbersComponent implements OnInit {
  id = ''; productId = ''; lstSectionConfigKeys: string[] = ["serial_num"]; isShowDummyHeight = false; statuses: KeyValueSet[];
  message: string = ''; isRedAlert: boolean = true; wrapper: KeyValues5; isExpiryAllowed = false; selectedDate: string; config = {};
  maxBodyHeight = 0; purchaseEntryDetailId = '0';
  elementIds: any = {
    serial_val: 'serial_val'
  };
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private configurationManagementService: ConfigurationManagementService, private productManagementService: ProductManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onSetDateConfig();
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      if (!this.statuses) {
        this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.SerialNumberStatus).subscribe(result => {
          this.statuses = result;
          this.wrapper = { key: '', v1: '', v2: '', v3: this.statuses[0].key, v4: '' } as KeyValues5;
        });
      } else {
        this.wrapper = { key: '', v1: '', v2: '', v3: this.statuses[0].key, v4: '' } as KeyValues5;
      }
    } else {
      this.productManagementService.getSerialNumber(this.id).subscribe(result => {
        this.wrapper = result;
        this.isExpiryAllowed = this.wrapper.v4 != '';
        if (this.isExpiryAllowed)
          this.selectedDate = this.wrapper.v4;
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.wrapper.v1 = this.productId;
      this.wrapper.v4 = this.isExpiryAllowed ? this.selectedDate : '';
      this.wrapper.v5 = this.purchaseEntryDetailId;
      this.productManagementService.saveSerialNumber(this.wrapper).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        switch (result.status) {
          case Status.Duplicate:
          case Status.Success: {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          } break;
        }
      });
    }
  }

  showHideDummyHeight(isShow: boolean) {
    this.isShowDummyHeight = isShow;
  }

  onSetDateConfig() {
    let today = this.localService.getDeviceDate();
    let date = today.getDate();
    let month = today.getMonth() + 1;
    this.selectedDate = (date.toString().length == 1 ? ('0' + date) : date) + '-' + (month.toString().length == 1 ? ('0' + month) : month) + '-' + today.getFullYear();
    this.config = { min: this.selectedDate, firstDayOfWeek: 'mo', showWeekNumbers: true, numOfMonthRows: 4, opens: 'left' };
  }

  doCheck() {
    this.isRedAlert = true;
    let message = '';
    if (!this.wrapper.v2 || this.wrapper.v2 == '' || this.wrapper.v2.trim() == '-') {
      message = this.localService.languageContent.serial_num.need_valid_serial;
      this.localService.onFocusNextInput(this.elementIds.serial_val, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }

  onSerialEnter(e) {
    if (e.target.value && (e.target.value.toString().includes(' ') || e.target.value.toString().includes('\t'))) {
      e.target.value = e.target.value.replace(/ /gi, "").replace(/\t/gi, "");
      this.wrapper.v2 = this.wrapper.v2.replace(/ /gi, "").replace(/\t/gi, "");
    }
  }
}
